module.exports = __webpack_public_path__ + "static/media/worker_event_img_under.27a62844.png";